module.exports = __webpack_public_path__ + "static/media/location.2b6c18c3.svg";